





























































































































import { TbMember, TbReturnOrder } from '@/http';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { dialogPanel } from "@/components";
@Component({
    components: {
        dialogPanel
    },
})
export default class morePay extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;
    @Prop({
        default:0
    })
    receivables:number;
    /**会员信息 */
    @Prop({
        type:Object,
        default:()=>{
            return {
                balance:0
            }
        }
    })
    memberInfo:any;
    /**审核信息 */
    @Prop({
        type:Object,
        default:()=>{
            return {
                
            }
        }
    })
    auditInfo:any;
    /**收银设置 */
    @Prop({
        type:Object,
        default:()=>{
            return {
                
            }
        }
    })
    paySetting:any;
    @Prop({
        default:false
    })
    isAli:Boolean;
    @Prop({
        default:false
    })
    isWechat:Boolean;
    @Prop({
        default:false
    })
    hasOfflineWeChat:Boolean;
    @Prop({
        default:false
    })
    hasOfflineAlipay:Boolean;
    @Prop({
        default:false
    })
    isDefaultGroupPay:boolean;

    fmoney = fmoney;

    /**选中的支付方式
     * 支持多选，最多三个
     * 1：现金
     * 2：会员卡
     * 3：微信
     * 4：支付宝
     * 5:线下微信
     * 6：线下支付宝
     */
     selectedPayType=[];
     /**是否开启组合支付 */
    isGroupPay = false;
    /**当前选中输入框-数字键盘选中用
     * 1:整单一口价
     * 2：整单折扣
     * 3：现金
     * 4：会员卡
     * 5：微信
     * 6：支付宝
     * 7: 线下微信
     * 8: 线下支付宝
     */
     inputType=null;
    /**输入框是否选中，首次点击输入框，清空数值用 */
    isInputSelected = false;
    /**支付方式 */
    cashVal=0;
    vipVal=0;
    wechatVal=0;
    aliVal=0;
    xlWechatVal=0;
    xlAliVal=0;

    /**键盘 */
    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }
    value = null;
    maxLength = 6;
    isNeedDot = true;
    /**默认支付方式 */
    defaultPayType = null;

    /**实收总额 */
    get receiptTotal(){
       let val = 0;
       let cashVal = this.cashVal?this.cashVal:0;
       let vipVal = this.vipVal?this.vipVal:0;
       let wechatVal = this.wechatVal?this.wechatVal:0;
       let aliVal = this.aliVal?this.aliVal:0;
       let xlWechatVal= this.xlWechatVal?this.xlWechatVal:0;
       let xlAliVal = this.xlAliVal?this.xlAliVal:0;
       val = calculate.addition(calculate.addition(calculate.addition(calculate.addition(calculate.addition(Number(cashVal),Number(vipVal)),Number(wechatVal)),Number(aliVal)),Number(xlWechatVal)),Number(xlAliVal));
       return val;
    }
    /**找零 */
    get changeVal(){
        let val = 0;
        if(this.selectedPayType.length==1&&this.selectedPayType.some(v=>v==1)){
            if(Number(this.receiptTotal)>Number(this.receivables)){
                val = calculate.subtraction(this.receiptTotal,this.receivables)
            }
        }
        return val;
    }

    /**匹配移动支付方式名称 */
    get getYdPayname(){
        let str = "微信/支付宝";
        if(this.selectedPayType.findIndex(v=>v==3)>-1){
            str = "微信";
        }else if(this.selectedPayType.findIndex(v=>v==4)>-1){
            str = "支付宝";
        }
        return str;
    }

    created() {
    }   
    
    mounted() {
        this.isGroupPay = this.isDefaultGroupPay;
       this.getDefaultPayMethod();
    }

    closeFun(){
        this.$emit('closeFun');
    }

    /**选择支付方式 */
    choosePayMethod(type){
        switch (type) {
            case 1:
                this.chargePayFun(1);
                break;
            case 2:
                if(this.getVipPayStatus()=="isDisable") return;
                this.chargePayFun(2);
                break;
            case 3:
                if(this.getWechatPayStatus()=="isDisable"){
                    if(!this.auditInfo.shopNo){
                        this.$emit('uAuthTipFun',1);
                    }
                    else if(this.auditInfo.shopNo&&this.auditInfo.approveStatus!=3){
                        this.$emit('uAuthTipFun',2);
                    }
                    return;
                };
                this.aliVal = 0;
                this.xlWechatVal = 0;
                this.xlAliVal = 0;
                this.selectedPayType = this.selectedPayType.filter(v=>v!=4&&v!=5&&v!=6);
                this.chargePayFun(3);
                break;
                case 4:
                if(this.getAliPayStatus()=="isDisable"){
                    if(!this.auditInfo.shopNo){
                        this.$emit('uAuthTipFun',1);
                    }
                    else if(this.auditInfo.shopNo&&this.auditInfo.alipayApproveStatus!=3){
                        this.$emit('uAuthTipFun',3);
                    }
                    return;
                };
                this.wechatVal = 0;
                this.xlWechatVal = 0;
                this.xlAliVal = 0;
                this.selectedPayType = this.selectedPayType.filter(v=>v!=3&&v!=5&&v!=6);
                this.chargePayFun(4);
                break;

            case 5:
                this.wechatVal =0;
                this.aliVal =0;
                this.xlAliVal =0;
                this.selectedPayType = this.selectedPayType.filter(v=>v!=3&&v!=4);
                this.chargePayFun(5);
                break;
            case 6:
                this.wechatVal =0;
                this.aliVal =0;
                this.xlWechatVal =0;
                this.selectedPayType = this.selectedPayType.filter(v=>v!=3&&v!=4);
                this.chargePayFun(6);
                break;
        
            default:
                break;
        }
        this.isInputSelected = false;
    }

    /**选择支付方式，如果选择2种，自动算第二种 */
    calcOhterVal2(nowType){
        if(this.selectedPayType.length!=2) return;
        let otherType = this.selectedPayType.filter(v=>v!=nowType)[0];
        let otherVal = calculate.subtraction(this.receivables,this.receiptTotal);
        if(otherVal<0){
            this.setInputVal(nowType);
        }else{
            switch (nowType) {
                case 1:
                    this.cashVal = otherVal;
                    break;
                case 2:
                    this.vipVal = Math.min(this.receivables,this.memberInfo.balance);
                    this.calcOhterVal(nowType,this.vipVal);
                    break;
                case 3:
                    this.wechatVal = otherVal;
                    break;
                case 4:
                    this.aliVal = otherVal;
                    break;
                case 5:
                    this.xlWechatVal = otherVal;
                    break;
                case 6:
                    this.xlAliVal = otherVal;
                    break;
            
                default:
                    break;
            } 
        }
    }

    chargePayFun(val){
        this.inputType = null;
        if(!this.isGroupPay){
            if(!this.selectedPayType.some(v=>v==val)){
                this.selectedPayType=[val];
                this.setInputVal(val);
            }
        }else{
            if(!this.selectedPayType.some(v=>v==val)){
                if(this.selectedPayType.length==3) return;
                this.selectedPayType.push(val);
                if(this.selectedPayType.length==1&&(val==3||val==4||val==5||val==6)){
                    this.setInputVal(val);
                }
                this.calcOhterVal2(val)
                
            }else{
                if(this.selectedPayType.length>1){
                    this.calcOhterVal(val,0);
                    this.clearInputVal(val);
                    this.selectedPayType = this.selectedPayType.filter(v=>v!=val);
                }
            }
        }
    }
    setInputVal(val){
        switch (val) {
            case 1:
                this.cashVal = this.receivables;
                this.vipVal = 0;
                this.wechatVal = 0;
                this.aliVal = 0;
                this.xlWechatVal = 0;
                this.xlAliVal = 0;
                break;
            case 2:
                this.cashVal = 0;
                this.vipVal = Math.min(this.receivables,this.memberInfo.balance);
                this.wechatVal = 0;
                this.aliVal = 0;
                this.xlWechatVal = 0;
                this.xlAliVal = 0;
                break;
            case 3:
                this.cashVal = 0;
                this.vipVal = 0;
                this.wechatVal = this.receivables;
                this.aliVal = 0;
                this.xlWechatVal = 0;
                this.xlAliVal = 0;
                break;
            case 4:
                this.cashVal = 0;
                this.vipVal = 0;
                this.wechatVal = 0;
                this.aliVal = this.receivables;
                this.xlWechatVal = 0;
                this.xlAliVal = 0;
                break;
            case 5:
                this.cashVal = 0;
                this.vipVal = 0;
                this.wechatVal = 0;
                this.aliVal = 0;
                this.xlWechatVal = this.receivables;
                this.xlAliVal = 0;
                break;
            case 6:
                this.cashVal = 0;
                this.vipVal = 0;
                this.wechatVal = 0;
                this.aliVal = 0;
                this.xlWechatVal = 0;
                this.xlAliVal = this.receivables;
                break;
        
            default:
                break;
        }
    }
    /**组合支付、仅有2种，输入一种，自动算第二种，两者相加为应收 */
    calcOhterVal(nowType,nowVal){
        if(this.selectedPayType.length!=2) return;
        let otherType = this.selectedPayType.filter(v=>v!=nowType)[0];
        let otherVal = calculate.subtraction(this.receivables,nowVal);
        switch (otherType) {
            case 1:
                this.cashVal = otherVal;
                break;
            case 2:
                this.vipVal = Math.min(otherVal,this.memberInfo.balance);
                break;
            case 3:
                this.wechatVal = otherVal;
                break;
            case 4:
                this.aliVal = otherVal;
                break;
            case 5:
                this.xlWechatVal = otherVal;
                break;
            case 6:
                this.xlAliVal = otherVal;
                break;
        
            default:
                break;
        } 
    }
    clearInputVal(val){
        switch (val) {
            case 1:
                this.cashVal = 0;
                break;
            case 2:
                this.vipVal = 0;
                break;
            case 3:
                this.wechatVal = 0;
                break;
            case 4:
                this.aliVal = 0;
                break;
            case 5:
                this.xlWechatVal = 0;
                break;
            case 6:
                this.xlAliVal = 0;
                break;
        
            default:
                break;
        }
        
    }
    /**支付方式，输入框状态 */
    getInputStatus(type){
        let str = "";
        switch (type) {
            case 1:
                if(!this.selectedPayType.some(v=>v==1)){
                    str = "isDisable"
                }else{
                    if(this.inputType==3&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;
            case 2:
                if(!this.selectedPayType.some(v=>v==2)||this.selectedPayType.length==1&&this.selectedPayType.some(v=>v==2)){
                    str = "isDisable"
                }else{
                    if(this.inputType==4&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;
            case 3:
                if(!this.selectedPayType.some(v=>v==3)&&!this.selectedPayType.some(v=>v==4)||(!this.isGroupPay&&(this.selectedPayType.some(v=>v==3)||this.selectedPayType.some(v=>v==4)))||(this.selectedPayType.length==1&&(this.selectedPayType.some(v=>v==3)||this.selectedPayType.some(v=>v==4)))){
                    str = "isDisable"
                }else{
                    if((this.inputType==5||this.inputType==6)&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;
            case 4:
                if(!this.selectedPayType.some(v=>v==5)||(!this.isGroupPay&&this.selectedPayType.some(v=>v==5))||(this.selectedPayType.length==1&&this.selectedPayType.some(v=>v==5))){
                    str = "isDisable"
                }else{
                    if(this.inputType==7&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;
            case 5:
                if(!this.selectedPayType.some(v=>v==6)||(!this.isGroupPay&&this.selectedPayType.some(v=>v==6))||(this.selectedPayType.length==1&&this.selectedPayType.some(v=>v==6))){
                    str = "isDisable"
                }else{
                    if(this.inputType==8&&this.isInputSelected){
                        str="isActive"
                    }
                }
                break;
        
            default:
                break;
        }
        return str;
    }
    selectInputFocus(type){
        if(type==3&&this.getInputStatus(1)=='isDisable') return;
        if(type==4&&this.getInputStatus(2)=='isDisable') return;
        if((type==5||type==6)&&this.getInputStatus(3)=='isDisable') return;
        if(type==7&&this.getInputStatus(4)=='isDisable') return;
        if(type==8&&this.getInputStatus(5)=='isDisable') return;
        this.isNeedDot = type==2?false:true;
        this.inputType = type;
        this.isInputSelected = true;
        this.value = null;
    }
    /**会员支付输入框-状态 */
    getVipPayStatus(){
        let str = "";
        if(!this.memberInfo.id||(this.memberInfo.id&&this.memberInfo.balance==0)){
            str="isDisable";
        }
        if(this.selectedPayType.some(v=>v==2)){
            str="isActive"
        }
        return str;
    }
    /**微信支付输入框-状态 */
    getWechatPayStatus(){
        let str = "";
        if(!this.isWechat){
            str="isDisable";
        }
        if(this.selectedPayType.some(v=>v==3)){
            str="isActive"
        }
        return str;
    }
    getAliPayStatus(){
        let str = "";
        if(!this.isAli){
            str="isDisable";
        }
        if(this.selectedPayType.some(v=>v==4)){
            str="isActive"
        }
        return str;
    }
    selectMfocus(){
        if(this.selectedPayType.some(v=>v==3)){
            this.selectInputFocus(5)
        }
        else if(this.selectedPayType.some(v=>v==4)){
            this.selectInputFocus(6)
        }
    }

    number(number) {
		// this.$emit("number", number);
        if(number=='.'&&!this.isNeedDot) return;
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}

    finishFun(){
        let value = this.value?this.value:0;
        // let value = this.value;
        switch (this.inputType) {
            // case 1:
            //     if(Number(value)<=Number(this.priceTotal)){
            //         this.discountPrice = value;
            //     }else{
            //         this.discountPrice = Number(this.priceTotal);
            //     }
            //     this.clearCoupon();
            //     this.calcFun();
            //     setTimeout(()=>{
            //         this.setPayal();
            //         this.calcMember();
            //     },2000)
            //     break;
            // case 2:
            //     this.clearCoupon();
            //     if(Number(value)<100){
            //         this.discount = value;
            //     }else{
            //         this.discount = 100;
            //     }
            //     this.calcFun();
            //     setTimeout(()=>{
            //         this.setPayal();
            //         this.calcMember();
            //     },2000)
            //     break;
            case 3:
                this.cashVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.cashVal>this.receivables&&this.selectedPayType.length>1){
                       this.cashVal = this.receivables; 
                       this.value = this.receivables; 
                    }
                    this.calcOhterVal(1,this.cashVal)
                })
                break;
            case 4:
                this.vipVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    let maxVal = Math.min(this.memberInfo.balance,this.receivables)
                    if(this.vipVal>maxVal){
                       this.vipVal = maxVal; 
                       this.value = maxVal; 
                    }
                    this.calcOhterVal(2,this.vipVal)
                })
                break;
            case 5:
                this.wechatVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.wechatVal>this.receivables){
                       this.wechatVal = this.receivables; 
                       this.value = this.receivables; 
                    }
                    this.calcOhterVal(3,this.wechatVal)
                })
                break;
            case 6:
                this.aliVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.aliVal>this.receivables){
                       this.aliVal = this.receivables; 
                       this.value = this.receivables; 
                    }
                    this.calcOhterVal(4,this.aliVal)
                })
                break;
            case 7:
                this.xlWechatVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.xlWechatVal>this.receivables){
                       this.xlWechatVal = this.receivables; 
                       this.value = this.receivables; 
                    }
                    this.calcOhterVal(5,this.xlWechatVal)
                })
                break;
            case 8:
                this.xlAliVal = value;
                /**判断是否超出应收 */
                this.$nextTick(()=>{
                    if(this.xlAliVal>this.receivables){
                       this.xlAliVal = this.receivables; 
                       this.value = this.receivables; 
                    }
                    this.calcOhterVal(6,this.xlAliVal)
                })
                break;
        
            default:
                break;
        }
        this.isInputSelected = false;
        this.$forceUpdate();
    }
    /**键盘 */
    del() {
		if(this.value){
            let index = this.value.length;
            this.value = index==1?0: this.value.toString().slice(0,index-1);
        }else{
            this.value = 0;
        }
		this.finishFun();
	}
    clearFun(){
		this.value = null;
		this.finishFun();
    }
    confirmSk(){
        let moreInfo={
            receivables:this.receiptTotal,
            giveChange:this.changeVal,
            cashVal:this.cashVal,
            vipVal:this.vipVal,
            wechatVal:this.wechatVal,
            aliVal:this.aliVal,
            xlWechatVal:this.xlWechatVal,
            xlAliVal: this.xlAliVal,
            selectedPayType:this.selectedPayType,
        }
        this.$emit('confirmSk',moreInfo);
    }
    groupPayChange(val){
        this.getDefaultPayMethod();
    }
    /**获取默认支付方式 */
    async getDefaultPayMethod(){
        if(this.memberInfo.id){
            if(this.paySetting.memberCard&&this.memberInfo.balance>=this.receivables){
                this.selectedPayType=[2];
                this.vipVal = Math.min(this.memberInfo.balance,this.receivables);
                this.cashVal = 0;
                this.wechatVal=0;
                this.aliVal=0;
                this.xlWechatVal = 0;
                this.xlAliVal = 0;
                this.defaultPayType=2;
            }else{
                this.searchDefaultPay();
            }
        }else{
            this.searchDefaultPay();
        }
        // console.log('selectedPayType',this.selectedPayType);
    }
    searchDefaultPay(){
        if(this.paySetting.paymentMethod){
            switch (this.paySetting.paymentMethod.value) {
                case "1":
                    this.selectedPayType=[1];
                    this.cashVal = this.receivables;
                    this.vipVal=0;
                    this.wechatVal=0;
                    this.aliVal=0;
                    this.xlWechatVal = 0;
                    this.xlAliVal = 0;
                    this.defaultPayType=1;
                    break;
                case "2":
                    this.selectedPayType=[3];
                    this.wechatVal = this.receivables;
                    this.cashVal=0;
                    this.vipVal=0;
                    this.aliVal=0;
                    this.xlWechatVal = 0;
                    this.xlAliVal = 0;
                    this.defaultPayType=3;
                    break;
                case "3":
                    this.selectedPayType=[4];
                    this.aliVal = this.receivables;
                    this.cashVal=0;
                    this.vipVal=0;
                    this.wechatVal=0;
                    this.xlWechatVal = 0;
                    this.xlAliVal = 0;
                    this.defaultPayType=4;
                    break;
            
                default:
                    break;
            }
        }else{
            this.selectedPayType=[1];
            this.cashVal = this.receivables;
            this.vipVal=0;
            this.wechatVal=0;
            this.aliVal=0;
            this.xlWechatVal = 0;
            this.xlAliVal = 0;
            this.defaultPayType=1;
        }
    }


   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/morePay.vue